// removed by extract-text-webpack-plugin
module.exports = {"field":"_1T2D0EfyNXVQcav8Z_RsMF","text":"rxx-pzH8teo2OxQo06cTq","thumb":"_1pMry4dAwHv6UewfjKIc8Q","ripple":"_1I9tvmn7yOKoE6x-u9e5xR","on":"p92Ype4Ui_TmPuZFYT92A","off":"_25ui_VhRD0mXt8qVXz8C_O","input":"_3BTU_VAdJHR4nTYZ2aqnhK","switch-on":"_2BwvewoDt4bmM4uqvMVsxa","switch-off":"_1ZBFp-ZgmVlFoCtrHJCv0W","disabled":"_1CQ_qYQhre8j8_OUgfzGSX _1T2D0EfyNXVQcav8Z_RsMF"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/switch/theme.css
// module id = 1048
// module chunks = 0